import * as Promise from 'bluebird';
import axios from 'axios';
import { I18n } from 'react-redux-i18n-lite';
import * as messageAlert from '../../messageAlertAction';
import * as ltiActions from '../../ltiActions';

export const openResource = openBookConfig => {
  return dispatch => {
    if (openBookConfig.lesson.format) {
      dispatch(openRemoteAsset(openBookConfig.lesson.url));
    } else {
      ltiActions.sendLTI(openBookConfig);
    }
  };
};

/**
 * Declared due cross-platform (in web version it does nothing)
 * @param classId
 * @param activityId
 * @param userId
 */
export const deleteBookPostAction = (classId = '', bookId = -1, activityId = '', userId = -1) => {
  return () => {
    return Promise.resolve();
  };
};

const openRemoteAsset = (url, ownWindow = false) => {
  return (dispatch, getState) => {
    return axios.get(url).then(res => {
      const resourceUrl = res.data.url;

      const isAppOnline = getState().connection.status.online;

      if (!isAppOnline) {
        dispatch(messageAlert.error(I18n.t('common.notAvailableOffline')));
      } else if (!resourceUrl) {
        dispatch(messageAlert.error(I18n.t('generic.notFound')));
      } else {
        const target = ownWindow ? '_self' : '_blank';
        window.open(resourceUrl, target);
      }
    });
  };
};
